export default {
  // Navigation
  nav_home: 'Startseite',
  nav_dashboard: 'Dashboard',
  nav_orders: 'Bestellungen',
  nav_wallet: 'Geldbörse',
  nav_analytics: 'Analytik',
  nav_referral: 'Empfehlung',
  nav_account: 'Konto',
  nav_notifications: 'Benachrichtigungen',
  nav_support: 'Support',
  nav_logout: 'Abmelden',
  nav_login: 'Anmelden',
  nav_signup: 'Registrieren',

  // Dashboard
  dashboard_welcome: 'Willkommen zurück',
  dashboard_total_earnings: 'Gesamteinnahmen',
  dashboard_pending_orders: 'Ausstehende Bestellungen',
  dashboard_completed_orders: 'Abgeschlossene Bestellungen',
  dashboard_commission_rate: 'Provisionssatz',
  dashboard_quick_actions: 'Schnellaktionen',
  dashboard_recent_orders: 'Letzte Bestellungen',
  dashboard_recent_activity: 'Letzte Aktivität',
  dashboard_wallet_balance: 'Geldbörsen-Guthaben',
  dashboard_deposit: 'Einzahlen',
  dashboard_withdraw: 'Abheben',
  dashboard_view_all: 'Alle Anzeigen',

  // Orders
  orders_title: 'Meine Bestellungen',
  orders_all: 'Alle Bestellungen',
  orders_pending: 'Ausstehend',
  orders_completed: 'Abgeschlossen',
  orders_cancelled: 'Storniert',
  orders_order_id: 'Bestellnummer',
  orders_platform: 'Plattform',
  orders_amount: 'Betrag',
  orders_commission: 'Provision',
  orders_status: 'Status',
  orders_date: 'Datum',
  orders_no_orders: 'Keine Bestellungen gefunden',

  // Wallet
  wallet_title: 'Meine Geldbörse',
  wallet_available_balance: 'Verfügbares Guthaben',
  wallet_pending_balance: 'Ausstehendes Guthaben',
  wallet_total_withdrawn: 'Gesamt Abgehoben',
  wallet_deposit_now: 'Jetzt Einzahlen',
  wallet_withdraw_now: 'Jetzt Abheben',
  wallet_transaction_history: 'Transaktionsverlauf',
  wallet_deposit_history: 'Einzahlungsverlauf',
  wallet_withdrawal_history: 'Abhebungsverlauf',
  wallet_deposit_desc: "Fügen Sie Geld zu Ihrer Wallet mit verfügbaren Zahlungsmethoden hinzu.",
  wallet_no_deposits: "Keine Einzahlungen gefunden.",
  wallet_withdraw_history: "Auszahlungsverlauf",
  wallet_withdraw_desc: "Geld aus Ihrer Wallet abheben.",
  wallet_no_withdrawals: "Keine Auszahlungen gefunden.",
  wallet_no_withdrawals_desc: "Sie haben noch keine Auszahlungen vorgenommen.",
  // Analytics
  analytics_title: 'Analytik',
  analytics_earnings_overview: 'Einnahmenübersicht',
  analytics_platform_breakdown: 'Plattform-Aufschlüsselung',
  analytics_performance_metrics: 'Leistungsmetriken',
  analytics_top_products: 'Top-Produkte',
  analytics_this_month: 'Dieser Monat',
  analytics_last_month: 'Letzter Monat',
  analytics_total_revenue: 'Gesamtumsatz',
  analytics_avg_order_value: 'Durchschn. Bestellwert',

  // Referral
  referral_title: 'Empfehlungsprogramm',
  referral_your_code: 'Ihr Empfehlungscode',
  referral_copy_code: 'Code Kopieren',
  referral_share_link: 'Link Teilen',
  referral_total_referrals: 'Gesamte Empfehlungen',
  referral_active_referrals: 'Aktive Empfehlungen',
  referral_referral_earnings: 'Empfehlungseinnahmen',
  referral_invite_friends: 'Freunde Einladen',

  // Account
  account_title: 'Kontoeinstellungen',
  account_profile: 'Profil',
  account_security: 'Sicherheit',
  account_notifications: 'Benachrichtigungen',
  account_kyc: 'KYC-Verifizierung',
  account_phone: 'Telefonnummer',
  account_two_factor: 'Zwei-Faktor-Authentifizierung',
  account_save_changes: 'Änderungen Speichern',
  account_cancel: 'Abbrechen',

  // Support
  support_title: 'Support-Center',
  support_faq: 'Häufig Gestellte Fragen',
  support_contact_us: 'Kontaktieren Sie Uns',
  support_live_chat: 'Live-Chat',
  support_ticket_tracker: 'Ticket-Tracker',
  support_submit_ticket: 'Ticket Einreichen',

  // Auth
  auth_email: 'E-Mail',
  auth_password: 'Passwort',
  auth_confirm_password: 'Passwort Bestätigen',
  auth_forgot_password: 'Passwort Vergessen?',
  auth_remember_me: 'Angemeldet Bleiben',
  auth_login_button: 'Anmelden',
  auth_signup_button: 'Registrieren',
  auth_already_have_account: 'Haben Sie bereits ein Konto?',
  auth_dont_have_account: 'Haben Sie kein Konto?',
  security_match_err: 'Passwörter stimmen nicht überein.',
  security_pin_6_err: 'Die PIN muss genau 6 Ziffern lang sein.',
  security_pin_digit_err: 'Die PIN darf nur aus Ziffern bestehen.',
  auth_reset_password: 'Passwort Zurücksetzen',
  auth_verify_email: 'E-Mail Verifizieren',

  // Common
  common_loading: 'Laden...',
  common_save: 'Speichern',
  common_cancel: 'Abbrechen',
  common_delete: 'Löschen',
  common_edit: 'Bearbeiten',
  common_view: 'Ansehen',
  common_search: 'Suchen',
  common_filter: 'Filtern',
  common_export: 'Exportieren',
  common_import: 'Importieren',
  common_submit: 'Absenden',
  common_close: 'Schließen',
  common_confirm: 'Bestätigen',
  common_success: 'Erfolg',
  common_error: 'Fehler',
  common_warning: 'Warnung',

  // Homepage
  home_hero_title: 'Verdienen Sie Provisionen von Top-E-Commerce-Plattformen',
  home_hero_subtitle: 'Schließen Sie sich Tausenden von Nutzern an, die täglich Provisionen von Walmart, Alibaba und AliExpress verdienen',
  home_get_started: 'Jetzt Starten',
  home_learn_more: 'Mehr Erfahren',
  home_how_it_works: 'Wie Es Funktioniert',
  home_features: 'Funktionen',
  home_commission_tiers: 'Provisionsstufen',
  home_testimonials: 'Was Unsere Nutzer Sagen',
  home_faq: 'Häufig Gestellte Fragen',
  home_cta_title: 'Bereit, Mit Dem Verdienen Zu Beginnen?',
  home_cta_subtitle: 'Treten Sie unserer Community bei und beginnen Sie, Provisionen zu verdienen',
  feature_6_title: '24/7 Support',
  feature_6_desc: 'Unser engagiertes Support-Team ist immer bereit zu helfen. Erhalten Sie Unterstützung über Live-Chat, E-Mail oder Telefon.',
  feature_6_detail_1: 'Live-Chat verfügbar',
  feature_6_detail_2: 'E-Mail-Support rund um die Uhr',
  feature_6_detail_3: 'Telefonische Unterstützung',
  feature_6_detail_4: 'Umfassendes FAQ',
  feature_7_title: 'Empfehlungsprogramm',
  feature_7_desc: 'Verdienen Sie zusätzliches Einkommen, indem Sie Freunde einladen. Erhalten Sie lebenslange Provisionen von den Einnahmen Ihrer Empfehlungen.',
  feature_7_detail_1: 'Lebenslange Empfehlungseinnahmen',
  feature_7_detail_2: 'Unbegrenzte Empfehlungen',
  feature_7_detail_3: 'Einfache Sharing-Tools',
  feature_7_detail_4: 'Bonus-Anreize',
  feature_8_title: 'Multiwährung',
  feature_8_desc: 'Unterstützung für die wichtigsten Währungen und Zahlungsmethoden. Wählen Sie aus, was für Sie am besten funktioniert.',
  feature_8_detail_1: 'USD, EUR, GBP Unterstützung',
  feature_8_detail_2: 'Banküberweisung verfügbar',
  feature_8_detail_3: 'E-Wallet-Integration',
  feature_8_detail_4: 'Kryptowährungsoptionen in Kürze',
  feature_9_title: 'Sofortige Benachrichtigungen',
  feature_9_desc: 'Bleiben Sie mit Echtzeit-Benachrichtigungen über neue Bestellungen, Einnahmen und Kontoaktivitäten auf dem Laufenden.',
  feature_9_detail_1: 'Push-Benachrichtigungen',
  feature_9_detail_2: 'E-Mail-Benachrichtigungen',
  feature_9_detail_3: 'SMS-Updates',
  feature_9_detail_4: 'In-App-Nachrichten',

  // Footer
  footer_about: 'Über Uns',
  footer_terms: 'Nutzungsbedingungen',
  footer_privacy: 'Datenschutzrichtlinie',
  footer_contact: 'Kontakt',
  footer_copyright: 'Alle Rechte vorbehalten',

  // Redesigned Footer
  footer_stay_loop_title: 'Bleiben Sie auf dem Laufenden',
  footer_stay_loop_desc: 'Erhalten Sie die neuesten Updates, Tipps und exklusiven Angebote direkt in Ihren Posteingang.',
  footer_subscribe: 'Abonnieren',
  footer_subscribe_placeholder: 'Geben Sie Ihre E-Mail-Adresse ein',
  footer_trusted_secure: 'VERTRAUENSWÜRDIG & SICHER:',
  footer_ssl_secured: 'SSL-gesichert',
  footer_ssl_secured_desc: '256-Bit SSL',
  footer_aes_encryption: 'AES-256 Verschlüsselung',
  footer_aes_encryption_desc: 'Bankenniveau',
  footer_kyc_compliant: 'KYC-konform',
  footer_kyc_compliant_desc: 'Verifiziert',
  footer_gdpr_compliant: 'DSGVO-konform',
  footer_gdpr_compliant_desc: 'Datenschutz garantiert',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'Zertifiziert',
  footer_platform: 'PLATTFORM',
  footer_support: 'SUPPORT',
  footer_legal: 'RECHTLICHES',
  footer_help_center: 'Hilfe-Center',
  footer_contact_us: 'Kontaktieren Sie uns',
  footer_payments_label: 'Zahlungen:',
  home_live_activity_title: 'Live-Plattform-Aktivität',
  home_recent_activity_title: 'Kürzliche Aktivitäten',
  home_total_commissions_paid: 'Gezahlte Gesamtomissionen',
  home_active_users_online: 'Aktive Benutzer online',
  home_tasks_completed_today: 'Heute abgeschlossene Aufgaben',
  account_security_row_title: 'Sicherheitseinstellungen',
  security_login_pw: 'Anmeldepasswort',
  security_login_pw_desc: 'Ändern Sie Ihr Konto-Anmeldepasswort',
  security_change_btn: 'Ändern',
  security_set_withdrawal_pw_title: 'Auszahlungspasswort festlegen',
  security_set_withdrawal_pw_desc: 'Erstellen Sie eine separate PIN zur Autorisierung von Auszahlungen',
  security_set_withdrawal_pw_btn: 'PIN festlegen',
  security_change_withdrawal_pw_title: 'Auszahlungspasswort ändern',
  security_change_withdrawal_pw_desc: 'Aktualisieren Sie Ihre vorhandene Auszahlungs-PIN',
  security_change_withdrawal_pw_btn: 'Ändern',
  security_modal_set_withdrawal_title: 'Auszahlungspasswort festlegen',
  security_modal_set_withdrawal_subtitle: 'Diese PIN wird jedes Mal benötigt, wenn Sie eine Auszahlung vornehmen.',
  security_modal_change_withdrawal_title: 'Auszahlungspasswort ändern',
  security_field_current_pin: 'Aktuelle Auszahlungs-PIN',
  security_field_new_pin: 'Neue Auszahlungs-PIN',
  security_field_new_pin_6: 'Neue Auszahlungs-PIN (6 Ziffern)',
  security_field_confirm_pin: 'PIN bestätigen',
  security_field_confirm_new_pin: 'Neue PIN bestätigen',
  security_placeholder_pin_dots: '......',
  security_pw_current: 'Aktuelles Passwort',
  account_security_tips_title: 'Sicherheitsempfehlungen',
  account_security_tips_desc: 'Verbessern Sie Ihren Kontoschutz, indem Sie diese einfachen Best Practices befolgen.',
  tip_password_title: 'Starkes Passwort',
  tip_password_desc: 'Verwenden Sie eine Kombination aus Buchstaben, Zahlen und Symbolen, um die Sicherheit Ihres Kontos zu gewährleisten.',
  tip_two_factor_title: 'Identitätsprüfung',
  tip_two_factor_desc: 'Halten Sie Ihre Kontaktinformationen auf dem neuesten Stand, um wichtige Sicherheitsbenachrichtigungen zu erhalten.',
  tip_logout_title: 'Regelmäßige Abmeldung',
  tip_logout_desc: 'Melden Sie sich immer von Ihrem Konto ab, wenn Sie öffentliche oder gemeinsam genutzte Computer verwenden.',
  tip_sharing_title: 'Zugriff nie teilen',
  tip_sharing_desc: 'Unser Support-Team wird Sie niemals nach Ihrem Passwort fragen. Teilen Sie Ihre Anmeldedaten niemals mit anderen.',

  // Bestellanfragen
  order_requests_title: 'Bestellanfragen',
  order_requests_desc: 'Senden Sie eine Anfrage für eine neue Aufgabe oder eine kundenspezifische Bestellung. Der Administrator wird die Aufgaben basierend auf Ihrer Anfrage prüfen und zuweisen.',
  order_requests_new_btn: 'Neue Bestellung anfragen',
  order_requests_table_id: 'Anfrage-ID',
  order_requests_table_data: 'Anfragedetails',
  order_requests_table_status: 'Status',
  order_requests_table_date: 'Eingereicht am',
  order_requests_table_actions: 'Aktionen',
  order_requests_cancel: 'Abbrechen',
  order_requests_cancel_confirm: 'Sind Sie sicher, dass Sie diese Bestellanfrage stornieren möchten?',
  order_requests_cancel_success: 'Bestellanfrage erfolgreich storniert.',
  order_requests_create_success: 'Bestellanfrage erfolgreich eingereicht.',
  order_requests_modal_title: 'Neue Bestellanfrage einreichen',
  order_requests_modal_desc: 'Bitte geben Sie detaillierte Informationen zu der Bestellung an, die Sie anfragen möchten.',
  order_requests_field_data: 'Bestellanfragedaten',
  order_requests_field_placeholder: 'z.B.: Ich möchte eine kundenspezifische Bestellung für das Premium-Paket anfragen.',
  order_requests_btn_submit: 'Anfrage senden',
  order_requests_btn_submitting: 'Senden...',
  order_requests_empty: 'Keine Bestellanfragen gefunden.',
  order_requests_status_pending: 'Ausstehend',
  order_requests_status_approved: 'Genehmigt',
  order_requests_status_rejected: 'Abgelehnt',
  order_requests_status_cancelled: 'Storniert',
  order_requests_terms_title: 'Verbindliche Bestellbedingungen',
  order_requests_term_1: 'Neue Bestellungen werden innerhalb von 24–48 Stunden nach der Genehmigung zugewiesen.',
  order_requests_term_2: 'Einmal freigegebene Bestellungen können nicht storniert, pausiert oder geändert werden.',
  order_requests_term_3: 'Alle zugewiesenen Bestellungen müssen vor einer Auszahlung abgeschlossen werden.',
  order_requests_term_4: 'Die Nichtvollendung von Bestellungen kann Ihren Kontostatus beeinträchtigen.',
  order_requests_term_5: 'Diese Anfrage ist endgültig und kann nach der Übermittlung nicht mehr rückgängig gemacht werden.',
  order_requests_policy_title: 'Keine Stornierungsrichtlinie',
  order_requests_policy_desc: 'Durch das Absenden dieser Anfrage erkennen Sie an, dass die neue Bestellung unwiderruflich ist. Sobald sie von unserem System bestätigt wurde, sind unter keinen Umständen Stornierungen, Änderungen oder Rückerstattungen zulässig.',
  order_requests_accept_terms: 'Ich habe die oben genannten Bedingungen gelesen und vollständig verstanden. Ich erkenne an, dass diese Bestellanfrage nach dem Absenden nicht mehr storniert oder geändert werden kann, und ich erkläre mich damit einverstanden, alle zugewiesenen Bestellungen abzuschließen.',

  // Orders Page (New Sections)
  orders_withdrawal_policy: 'Auszahlungsrichtlinie',
  orders_unlock_req: 'Anforderungen zum Freischalten',
  orders_unlock_desc: 'Schließen Sie Ihren ersten Stapel von {{count}} Bestellungen ab, um Auszahlungen dauerhaft freizuschalten. Diese einmalige Anforderung gewährleistet die Integrität der Plattform und verhindert Missbrauch.',
  orders_daily_limits: 'Tägliche Bestelllimits',
  orders_daily_limit_1: '{{count}} Bestellungen pro Stapel — alle müssen vor der Anforderung des nächsten abgeschlossen werden',
  orders_daily_limit_2: 'Maximal {{count}} Stapel pro Tag ({{total}} Bestellungen/Tag)',
  orders_comm_rates: 'Provisionssätze',
  orders_comm_rates_desc: 'Die Sätze werden durch die Plattform und Ihr aktuelles Wallet-Guthaben bestimmt:',
  orders_payout_timeline: 'Auszahlungszeitplan',
  orders_payout_desc: 'Auszahlungen werden innerhalb von 24-48 Stunden bearbeitet. Banküberweisungen können 3-5 Werktage dauern. Krypto-Auszahlungen erfolgen sofort.',
  orders_processing_fee: 'Für alle Auszahlungen fällt eine Bearbeitungsgebühr von {{fee}}% an, um die Transaktionskosten zu decken.',
  orders_tips_title: 'Tipps für den Erfolg',
  orders_tips_1: 'Schließen Sie täglich Bestellungen ab, um Dynamik aufzubauen und Einnahmen zu maximieren',
  orders_tips_2: 'Bleiben Sie während der Verarbeitung auf der Seite, um den ordnungsgemäßen Abschluss sicherzustellen',
  orders_tips_3: 'Überprüfen Sie regelmäßig Ihr Wallet, um das Provisionswachstum zu verfolgen',
  orders_tips_4: 'Empfehlen Sie Freunde, um Bonusprovisionen auf deren Bestellungen zu verdienen',
  orders_tips_5: 'Kontaktieren Sie umgehend den Support, wenn Probleme auftreten',
  orders_batch_approx: '{{count}} Bestellungen/Charge × Durchschnitt ${{avg}} = ca. ${{total}} pro Charge',

  // Settings
  settings_page_title: 'Einstellungen',
  settings_page_desc: 'Verwalten Sie Ihre Sicherheit, Privatsphäre und Einstellungen',
  settings_kyc_label: 'KYC-Überprüfung',
  settings_kyc_desc: 'Identitätsprüfung',
  settings_security_label: 'Sicherheit',
  settings_security_desc: 'Passwortverwaltung',
  settings_language_label: 'Sprache',
  settings_language_desc: 'Regionale Einstellungen',
};